import { FC, useEffect } from 'react';
import SuperAutoComplete, { SuperAutoCompleteProps } from '../SuperAutoComplete';
import SimpleFormDisabled from './subpage/disabled';
import SimpleFormItem from './subpage/simpleFormItem';
import { BaseSimpleFormProps, SimpleFormItemEnum } from './interface';
import { NamePath } from '../constants/interface';
import { ProInput } from '../antd';
import { OPTION_KEY } from '../SuperAutoComplete/interface';
import { FormInstance } from 'antd/lib/form';

export interface SimpleFormSuperAutoCompleteProps extends BaseSimpleFormProps {
  superAutoCompleteProps?: SuperAutoCompleteProps;
  /** 标签表单值 */
  labelValue?: any;
}
const SimpleFormSuperAutoComplete: FC<SimpleFormSuperAutoCompleteProps> = props => {
  const { disabledRender, superAutoCompleteProps, form, name, labelValue, ...restProps } = props;
  let valueName: NamePath | undefined = '';
  let labelName: NamePath | undefined = '';
  if (Array.isArray(name) && name.length === 2) {
    valueName = name[0];
    labelName = name[1];
  } else {
    valueName = name[0];
  }
  useEffect(() => {
    if (labelName) {
      form?.setFieldValue(labelName, labelValue);
    }
  }, [labelValue]);
  const handleChange = (value?: any, item?: any, _?: FormInstance, index?: number, record?: any) => {
    if (labelName) {
      form?.setFieldValue(labelName, item?.[superAutoCompleteProps?.labelKey || OPTION_KEY.LABEL]);
    }
    superAutoCompleteProps?.onChange?.(value, item, form, index, record);
  };

  return (
    <>
      <SimpleFormItem {...restProps} name={valueName}>
      {superAutoCompleteProps?.disabled ? (
        <SimpleFormDisabled
          name={valueName}
          form={form}
          render={disabledRender}
        />
      ) : (
        <SuperAutoComplete
          {...superAutoCompleteProps}
          onChange={handleChange}
        />
      )}
      </SimpleFormItem>
      {!!labelName && (
        <SimpleFormItem
          hidden={true}
          name={labelName}
          style={{ padding: 0, margin: 0 }}
        >
          <ProInput />
        </SimpleFormItem>
      )}
    </>
  );
};

SimpleFormSuperAutoComplete.displayName = SimpleFormItemEnum.SimpleFormSuperAutoComplete;

export default SimpleFormSuperAutoComplete;